import path from './path'

const config = {
  path,
  version: `0.1`,
  formData: true,
  //请求配置处理
  request: {},
}

export default config
